import React from 'react';
import './App.css';

import RoutesConfig from './routes'

const App = () => <RoutesConfig />

export default App;
